import { render, staticRenderFns } from "./Recipients.vue?vue&type=template&id=2d0f9bb4&scoped=true"
import script from "./Recipients.vue?vue&type=script&lang=js"
export * from "./Recipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f9bb4",
  null
  
)

export default component.exports